/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {logInfo} from "App/debug";

export default
class ProjectInfo {

    private _modelDescription: Description;
    private _properties: any;

    constructor(aModelDescription: Description) {
        this._modelDescription = aModelDescription;

        // default values
        this._properties = {
            projectGUID: "",
            modelName: "",
            source: "",
            webglDeployVersion: ""
        };
    }

    public getProperties(): any {
        let props = {};
        for (let key in this._properties) {
            props[key] = this._properties[key];
        }
        return props;
    }

    public setFromExportInfoCompatibility(aExportInfoJSON: any) {
        this._properties = {
            projectGUID: "",
            modelName: aExportInfoJSON.modelName,
            source: aExportInfoJSON.lexocadVersion,
            webglDeployVersion: aExportInfoJSON.webglDeployVersion
        };
    }

    public parse(aModelDescriptionJSON: any): boolean {
        if (!aModelDescriptionJSON.hasOwnProperty("ProjectInfo")) {
            return false;
        }

        for (let key in aModelDescriptionJSON.ProjectInfo) {
            if (this._properties[key] !== undefined) {
                this._properties[key] = aModelDescriptionJSON.ProjectInfo[key];
            } else {
                logInfo("Error: property '" + key + "' is nor member of the project info settings.");
            }
        }

        return true;
    }

    public getJSONRepresentation(): any {
        return this.getProperties();
    }
}
